import i18nFlowSaga from './lang/saga';
import infoSaga from './Containers/Info/service/saga';
import menuSaga from './Containers/Menu/service/saga';
import authAutoFlowSaga from './service/auth/saga';
import paymentTypeSaga from './Containers/Partners/Components/Binding/service/saga';
import exportSaga from './Containers/Partners/service/saga';
import routerSaga from './route/saga';
import variableSaga from './Containers/VariableServer/service/saga';
import confirmSaga from './Components/ConfirmRedux/service/saga';
import redirectSaga from './service/redirect/saga';
import errorSaga from './Components/ErrorBoundary/services/saga';
import { all } from 'redux-saga/effects';
import userSaga from './service/user/saga';
import MasterBarSaga from './Components/MasterBar/service/saga';
import timeslotSaga from './service/timeslot/saga';

export default function* indexSaga() {
	yield all([
		i18nFlowSaga(),
		routerSaga(),
		authAutoFlowSaga(),
		infoSaga(),
		menuSaga(),
		paymentTypeSaga(),
		exportSaga(),
		variableSaga(),
		confirmSaga(),
		redirectSaga(),
		errorSaga(),
		userSaga(),
		MasterBarSaga(),
		timeslotSaga(),
	]);
}
